import React from 'react';
import {APP_NO_IMG} from "../../../const/root";

interface Props {
    src: string

}

export class ImgProduct extends React.Component<Props, {}> {
    // @ts-ignore
    addDefaultSrc = ev => {
        ev.target.src = APP_NO_IMG;
    }


    render() {

        let src: string = this.props.src

        return (
          <div style={{maxWidth: 100, padding:10 }}>
                <img
                    style={{width: "70px", maxHeight: 110}}
                    src={src}
                    onError={this.addDefaultSrc}
                    alt="good.png"/>
            </div>


        )
    }
}

